import { render } from "./index.vue?vue&type=template&id=108951aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=108951aa&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-108951aa"

export default script